import React from 'react';
import { Redirect } from 'react-router-dom';
import LabsContainer from './admin-labs-container'; // to be uncommented
import AdminTeamPageContainer from '../teams/admin-page-container';
import AdminLinkingContainer from './admin-linking-container';
import AdminManageDealContainer from './admin-manage-deal-container';
import AdminManageSettings from './admin-manage-settings';
import AdminManageCProUsers from './admin-manage-cpro-users';
import AdminManagePoolAccounts from './admin-manage-pool-accounts';

const subroutes = [
  {
    path: '/admin/',
    exact: true,
    component: () => <Redirect to="/admin/labs" />,
  },
  {
    path: '/admin/labs',
    exact: true,
    component: LabsContainer,
  },
  {
    path: '/admin/teams',
    exact: true,
    component: AdminTeamPageContainer,
  },
  {
    path: '/admin/linking',
    exact: true,
    component: AdminLinkingContainer,
  },
  {
    path: '/admin/manage-deal',
    exact: true,
    component: AdminManageDealContainer,
  },
  {
    path: '/admin/manage-settings',
    exact: true,
    component: AdminManageSettings,
  },
  {
    path: '/admin/manage-cpro-users',
    exact: true,
    component: AdminManageCProUsers,
  },
  {
    path: '/admin/manage-pool-accounts',
    exact: true,
    component: AdminManagePoolAccounts,
  },
];

export default subroutes;
